(function () {
  'use strict';

  var RING_ORIGIN = '776 595';
  var DURATION = 30;
  var MAX_BOOST = 7;
  var BOOST_PER_PX = 0.12;
  var RETURN = 0.045;
  var EASE_TS = 0.12;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var hosts = [];
  var hero = document.querySelector('[data-luxe][data-hero-3d]');
  if (hero) hosts.push(hero);
  Array.prototype.forEach.call(document.querySelectorAll('[data-metric-dial]'), function (el) {
    if (hosts.indexOf(el) === -1) hosts.push(el);
  });
  if (!hosts.length) return;

  function createDial(root) {
    var shell = root.querySelector('.luxe-hero__metric-shell');
    if (!shell) return null;

    var innerTween = null, outerTween = null;
    var speed = 1, targetSpeed = 1;
    var started = false, paused = false, offscreen = false;

    function getSvg() {
      return shell.querySelector('svg');
    }

    function applySpeed(s) {
      if (innerTween) innerTween.timeScale(s);
      if (outerTween) outerTween.timeScale(s);
    }

    function syncPlay() {
      var play = !paused && !offscreen;
      if (innerTween) { play ? innerTween.resume() : innerTween.pause(); }
      if (outerTween) { play ? outerTween.resume() : outerTween.pause(); }
      if (play) applySpeed(speed);
    }

    function frame(s) {
      if (!paused && !offscreen) {
        targetSpeed = Math.min(targetSpeed + s.speed * BOOST_PER_PX, MAX_BOOST);
      }

      targetSpeed += (1 - targetSpeed) * RETURN;
      speed += (targetSpeed - speed) * EASE_TS;

      if (Math.abs(speed - 1) > 0.01 || Math.abs(targetSpeed - 1) > 0.01) {
        if (!paused && !offscreen) applySpeed(speed);
        return true;
      }

      if (speed !== 1) {
        speed = targetSpeed = 1;
        if (!paused && !offscreen) applySpeed(1);
      }
      return false;
    }

    function boot() {
      if (started) return;
      var svg = getSvg();
      if (!svg) return;
      started = true;

      var gsap = window.gsap;
      if (!gsap) { svg.style.visibility = 'visible'; return; }

      var inner = svg.querySelector('#inner-metric');
      var outer = svg.querySelector('#outer-metric');

      if (reduce) {
        gsap.set(svg, { autoAlpha: 1, scale: 1, rotation: 0, transformOrigin: '50% 50%' });
        return;
      }

      if (window.CustomEase && !window.CustomEase.get('metricSmooth')) {
        window.CustomEase.create('metricSmooth', '0.16, 1, 0.3, 1');
      }
      var ease = window.CustomEase && window.CustomEase.get('metricSmooth') ? 'metricSmooth' : 'power3.out';

      gsap.set(svg, { autoAlpha: 0, scale: 1.2, rotation: 12, transformOrigin: '50% 50%' });
      var tl = gsap.timeline({ defaults: { duration: 3, ease: ease }, onComplete: startSpin });
      tl.to(svg, { autoAlpha: 1, scale: 1, rotation: 0 }, 0);
      if (inner) tl.from(inner, { rotation: -300, svgOrigin: RING_ORIGIN }, 0);
      if (outer) tl.from(outer, { rotation: 300, svgOrigin: RING_ORIGIN }, 0);

      function startSpin() {
        if (inner) {
          innerTween = gsap.to(inner, {
            rotation: '+=360', svgOrigin: RING_ORIGIN, duration: DURATION, ease: 'none', repeat: -1
          });
        }
        if (outer) {
          outerTween = gsap.to(outer, {
            rotation: '-=360', svgOrigin: RING_ORIGIN, duration: DURATION, ease: 'none', repeat: -1
          });
        }
        applySpeed(speed);
        if (window.LuxeScroll) window.LuxeScroll.register({ paint: frame });

        if ('IntersectionObserver' in window) {
          var watch = root.querySelector('.luxe-hero') || root;
          var io = new IntersectionObserver(function (e) {
            offscreen = !e[0].isIntersecting;
            syncPlay();
          }, { threshold: 0 });
          io.observe(watch);
        }
      }
    }

    return {
      shell: shell,
      boot: boot,
      setPaused: function (p) {
        paused = p;
        syncPlay();
      }
    };
  }

  var dials = hosts.map(createDial).filter(Boolean);
  if (!dials.length) return;

  document.addEventListener('vici:motion', function (e) {
    var p = !(e.detail && e.detail.playing);
    dials.forEach(function (d) {
      d.setPaused(p);
    });
  });

  function whenReady() {
    dials.forEach(function (d) {
      if (d.shell.querySelector('svg')) {
        d.boot();
      } else {
        document.addEventListener('czard:metric-ready', function () {
          d.boot();
        });
      }
    });
  }

  if (window.__czardIntro) whenReady();
  else document.addEventListener('czard:intro', whenReady, { once: true });
})();
